import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, BUSINESS_NAME } from "../../lib/business";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-zinc-950/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 sm:h-20">
        {/* Logo */}
        <a
          href="#top"
          data-testid="site-logo"
          aria-label={BUSINESS_NAME}
          className="flex items-center group"
        >
          <img
            src="/logo.jpg"
            alt={BUSINESS_NAME}
            className="h-10 sm:h-12 w-auto rounded-md bg-white p-1 shadow-[0_4px_20px_-6px_rgba(255,255,255,0.25)] transition-transform duration-200 group-hover:scale-[1.03]"
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-display text-sm uppercase tracking-widest text-zinc-400 hover:text-white transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* CTA + mobile toggle */}
        <div className="flex items-center gap-3">
          <a
            href={PHONE_TEL}
            data-testid="call-now-header"
            className="hidden sm:inline-flex items-center gap-2 bg-[#E10600] hover:bg-[#FF2D1A] text-white font-display uppercase tracking-wide font-bold px-5 py-3 rounded-full transition-colors duration-200"
          >
            <Phone className="w-4 h-4" />
            <span className="text-sm">{PHONE_DISPLAY}</span>
          </a>
          <button
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/10 text-white"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-zinc-950/95 backdrop-blur-xl border-t border-white/10"
        >
          <div className="px-4 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className="font-display text-lg uppercase tracking-widest text-zinc-300 hover:text-white"
              >
                {item.label}
              </a>
            ))}
            <a
              href={PHONE_TEL}
              data-testid="call-now-mobile-menu"
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#E10600] text-white font-display uppercase tracking-wide font-bold px-5 py-3 rounded-full"
            >
              <Phone className="w-4 h-4" /> Call {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
